import React, { Suspense, useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Images } from "../../ImageController/Index";
import { Button, Form, Input, Spin } from "antd";
import { emailPattern, makeLabel, setLocalStorageItem } from "../../Utils";
import { FacebookAuth, getLoginImage, GoogleAuth, userLogin } from "./AuthFun";
import { NavLink, useNavigate } from "react-router-dom";
import { UPLOAD_ENDPOINT } from "../../ApiServices/Axios/Index";

const Login = () => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [loginImage, setLoginImage] = useState("");
  const navigate = useNavigate();
  const handleLogin = (val) => {
    setBtnLoading(true);
    userLogin(val)
      .then((res) => {
        if (res.success) {
          setLocalStorageItem("accessToken", res.token);
          setLocalStorageItem("IsLoggesIn", true);
          navigate("/content/contentData");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  return (
    <Suspense
      fallback={
        <div className="flex justify-center items-center h-screen">
          <Spin spinning={true}></Spin>
        </div>
      }
    >
      <div className=" flex justify-center items-center h-screen">
        <div className="grid grid-cols-2 place-items-center border border-gray-300 p-16">
          <div className="w-full bg-authBg h-screen hidden md:flex justify-center items-center ">
            <LazyLoadImage
              src="/demo_logo.jpg"
              alt="signupimage"
              className="w-[100%] h-screen object-cover "
            />
          </div>

          <div className="w-full h-screen flex justify-center items-center col-span-2 md:col-span-1">
            <div className="w-3/4 m-auto">
              <div className="font-poppins text-start text-2xl font-normal mb-8">
                <p>Login</p>
              </div>
              <Form onFinish={(val) => handleLogin(val)}>
                <Form.Item
                  name={"email"}
                  rules={[
                    {
                      required: true,
                      message: "Email Is Required",
                    },
                    {
                      pattern: emailPattern,
                      message: "Please Enter Valid Email",
                    },
                  ]}
                  labelCol={{ span: 24 }}
                  label={makeLabel("Email Address")}
                >
                  <Input
                    placeHolder="Email address"
                    className="authinput hover:border p-3 hover:border-gray-300 hover:shadow-none focus-within:border focus-within:border-gray-300 focus:border focus:border-gray-300"
                  />
                </Form.Item>
                <Form.Item
                  name={"password"}
                  rules={[
                    {
                      required: true,
                      message: "Password Is Required",
                    },
                  ]}
                  labelCol={{ span: 24 }}
                  label={makeLabel("Password")}
                >
                  <Input.Password
                    className="rounded-md hover:border p-3 hover:border-gray-300 hover:shadow-none focus-within:border focus-within:border-gray-300 focus:border focus:border-gray-300"
                    placeholder="Password"
                    // iconRender={(visible) => (
                    //   <NavLink to={"/forgetPassword"}>
                    //     <p
                    //       style={{
                    //         color: "#1890ff",
                    //         cursor: "pointer",
                    //         fontSize: "12px",
                    //       }}
                    //     >
                    //       Reset Password
                    //     </p>
                    //   </NavLink>
                    // )}
                  />
                </Form.Item>

                <div className="flex items-center mt-4 ">
                  <Button
                    loading={btnLoading}
                    htmlType="submit"
                    prefix="jj"
                    className="NoButtonHover font-poppins p-5 text-white  rounded-md bg-primary w-full bg-gradient-to-l from-[#e69900] to-[#b37700]"
                  >
                    Log In
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default Login;
